import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import "./EsameDetailPage.css";

const EsameVestibolarePage: React.FC = () => {
  return (
    <div className="esame-detail-page">
      <div className="esame-detail-container">
        <Link to="/esami" className="esame-detail-back">
          <FontAwesomeIcon icon={faArrowLeft} />
          Torna agli esami
        </Link>

        <div className="esame-detail-content">
          <div className="esame-detail-text">
            <h1 className="esame-detail-title">
              Esame Vestibolare
            </h1>

            <div className="esame-detail-description">
              <h2>Cos'è</h2>
              <p>
                Test non invasivo e indolore fondamentale per diagnosticare le cause di vertigini, 
                instabilità e disturbi dell'equilibrio attraverso prove cliniche e strumentali.
              </p>

              <h2>Come si svolge</h2>
              <p>
                L'esame vestibolare comprende una serie di test che valutano il sistema dell'equilibrio. 
                Il paziente viene sottoposto a diverse prove cliniche che possono includere movimenti 
                della testa, cambiamenti di posizione e osservazione dei movimenti oculari. Possono essere utilizzate apparecchiature strumentali per una valutazione più 
                approfondita del sistema vestibolare.
              </p>

              <h2>A cosa serve</h2>
              <p>
                L'esame vestibolare permette di:
              </p>
              <ul>
                <li>Diagnosticare le cause di vertigini e capogiri</li>
                <li>Valutare disturbi dell'equilibrio e instabilità posturale</li>
                <li>Identificare patologie del sistema vestibolare (labirinto)</li>
                <li>Distinguere tra vertigini di origine periferica o centrale</li>
                <li>Monitorare l'evoluzione di disturbi vestibolari</li>
                <li>Pianificare il trattamento riabilitativo più appropriato</li>
              </ul>
            </div>
          </div>

          <div className="esame-detail-image-container">
            <img
              src={require("../assets/photos/main-photo.jpg")}
              alt="Esame Vestibolare"
              className="esame-detail-image"
            />
          </div>
        </div>

        <div className="esame-detail-cta">
          <h3>Vuoi prenotare questo esame?</h3>
          <p>
            Contattaci per maggiori informazioni o per fissare un appuntamento
          </p>
          <Link to="/#prenota" className="esame-detail-cta-btn">
            Prenota ora
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EsameVestibolarePage;
